import { fileTypeFromBlob } from 'file-type'
import { SourceMimeType } from '../../const'

export interface FileTypeResult {
  readonly ext: string
  readonly mime: string
}

/** file-type не поддерживает SVG (текстовый формат) — минимальный fallback */
const SVG_HEADERS = ['<?xml', '<svg']

async function detectSvgFromBlob(blob: Blob): Promise<FileTypeResult | undefined> {
  const slice = blob.slice(0, 100)
  const text = await slice.text()

  if (SVG_HEADERS.some(header => text.trimStart().startsWith(header))) {
    return { ext: 'svg', mime: SourceMimeType.Svg }
  }

  return undefined
}

/**
 * Определяет тип файла по содержимому (magic bytes).
 * Обёртка над file-type с fallback для SVG.
 * @param blob - Blob или File для анализа
 * @returns Результат с ext и mime, или undefined если тип не определён
 */
export async function detectFileTypeFromBlob(
  blob: Blob,
): Promise<FileTypeResult | undefined> {
  const result = await fileTypeFromBlob(blob)

  if (result) {
    return result
  }

  return detectSvgFromBlob(blob)
}
